import { render } from "./SongLyrics.vue?vue&type=template&id=42d2df74&scoped=true"
import script from "./SongLyrics.vue?vue&type=script&lang=js"
export * from "./SongLyrics.vue?vue&type=script&lang=js"

import "./SongLyrics.vue?vue&type=style&index=0&id=42d2df74&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d2df74"]])

export default __exports__